import { useMutation, useQuery } from "@apollo/client";
import { CircularProgress } from "@material-ui/core";
import React, { useContext, useState,useEffect } from "react";
import SnackbarContext from "../../../Context/SnackbarContext";
import DeleteModal from "../../UI/DeleteModal/DeleteModal";
import Empty from "../../UI/Empty/Empty";
import SearchBox from "../../UI/SearchBox/SearchBox";
import { Pagination } from "../Report/Report";
import "./ContactUs.scss";
import {
    DeleteContactUs,
    GetContactUs,
    GetContactUsCount,
} from "./ContactUsQuery";
import ContactUsDetail from "./ContactUsDetail/ContactUsDetail";
import APP from '../../../services/app-service';
const GLOBAL = require('../../../services/global-constant');
const axios = require('axios').default;

const Promocode: React.FC = () => {
    const [searchString, setCodeSearch] = useState<string>("");
    const [editData, setEditData] = useState<any>(null);
    const [addModal, setAddModal] = useState<boolean>(false);
    const [limit] = useState(7);
    const [offset, setOffset] = useState(0);

    // const { setSnackbar, setMessage } = useContext(SnackbarContext);

    const [contactUs, setContactUs] = useState<any>(null);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);

    const [contactUsCount, setContactUsCount] = useState(0);
    const [errorCount, setErrorCount] = useState();
    const [countLoading, setCountLoading] = useState(false);

    // const { data: contactUs, error, loading, refetch } = useQuery(
    //     GetContactUs,
    //     {
    //         variables: {
    //             searchString: `%${searchString}%`,
    //             limit,
    //             offset,
    //         },
    //     }
    // );

    // const {
    //     data: contactUsCount,
    //     error: errorCount,
    //     loading: countLoading,
    //     refetch: countRefetch,
    // } = useQuery(GetContactUsCount, {
    //     variables: {
    //         searchString: `%${searchString}%`,
    //     },
    // });

    useEffect(() => {
        refetch();
    },[offset]);

    const refetch = async () => {
        console.log("dsd");
        setLoading(true);
        setCountLoading(true);
        axios.post(GLOBAL.BASE_URL+GLOBAL.ENDPOINTS.getContactUs,{
            limit:limit,
            offset:offset,
        },APP.getToken())
        .then(function (response:any) {
            if(!response.data.error){
                setContactUs(response.data);
                setContactUsCount(response.data.count);
            }else{
                setError(response.data.message);
            }
            setLoading(false);
            setCountLoading(false);
        })
        .catch(function (error:any) {
            console.log("error",error);
        });
	};

    if (error || errorCount) {
        return <Error error={error ? error : errorCount} />;
    }

    const callRefetch = () => {
        refetch();
        //countRefetch();
    };

    return (
        <div className="container-main">
            <ContactUsDetail
                isOpen={addModal}
                setModal={setAddModal}
                refetch={callRefetch}
                setEditData={setEditData}
                editData={editData}
            />
            <div className="w-40">
                <SearchBox
                    placeholder="Search using email"
                    onChangeSearch={(value) => {
                        setCodeSearch(value);
                    }}
                />
            </div>
            <div className="promo__box">
                <div className="promo__main">
                    <div className="promo__header">
                        <p>Contact Us</p>
                    </div>

                    <PromoTitle />
                    {loading ? (
                        <div className="spinner-container">
                            <CircularProgress size={40} thickness={4} />
                        </div>
                    ) : contactUs && contactUs.contact_us.length > 0 ? (
                        contactUs.contact_us.map((element: any) => {
                            return (
                                <PromoItem
                                    element={element}
                                    refetch={callRefetch}
                                    key={element.id}
                                    onClickEdit={() => {
                                        setEditData(element);
                                        setAddModal(true);
                                    }}
                                />
                            );
                        })
                    ) : (
                        <Empty />
                    )}
                </div>

                {!loading && !countLoading && (
                    <Pagination
                        limit={limit}
                        offset={offset}
                        count={
                            contactUsCount
                        }
                        changeOffset={(value: any) => setOffset(value)}
                    />
                )}
            </div>
        </div>
    );
};

export default Promocode;

const PromoTitle: React.FC = () => {
    return (
        <div className="contact__table">
            <p className="promo__title">Name</p>
            <p className="promo__title">Email</p>
            <p className="promo__title">Phone</p>
        </div>
    );
};

interface PromoItemProps {
    element: any;
    refetch: () => void;
    onClickEdit: () => void;
}

const PromoItem: React.FC<PromoItemProps> = ({
    element,
    refetch,
    onClickEdit,
}: PromoItemProps) => {
    const { setSnackbar, setMessage } = useContext(SnackbarContext);

    // const [togglePromoCodeIsDeletedMutation] = useMutation(
    //     togglePromoCodeIsDeleted
    // );

    const [deleteContactUsMutation] = useMutation(DeleteContactUs);

    const [loading, setLoading] = useState(false);

    const [modal, setModal] = useState(false);

    // const toggleIsDeleted = () => {
    //     setLoading(true);
    //     togglePromoCodeIsDeletedMutation({
    //         variables: {
    //             id: element.id,
    //             isDeleted: !element.isDeleted,
    //         },
    //     })
    //         .then(({ data }) => {
    //             setSnackbar(true);
    //             setMessage("Status updated Successfully");
    //             setLoading(false);
    //             refetch();
    //         })
    //         .catch((error) => {
    //             setSnackbar(true);
    //             setMessage(error.message);
    //         });
    // };

    const deleteContactUs = () => {
        setLoading(true);
        axios.post(GLOBAL.BASE_URL+GLOBAL.ENDPOINTS.deleteContactUs,{
            contactUsId: element.id,
        },APP.getToken())
        .then(function (response:any) {
            if(!response.data.error){
                setSnackbar(true);
                setMessage("Form Deletion Successful");
                setLoading(false);
                setModal(false);
                refetch();
            }else{
                setSnackbar(true);
                setMessage(response.data.message);
            }
            setLoading(false);
        })
        .catch(function (error:any) {
            setSnackbar(true);
            setMessage(error);
        });

        // setLoading(true);
        // deleteContactUsMutation({
        //     variables: {
        //         contactUsId: element.id,
        //     },
        // })
        //     .then(({ data }) => {
        //         setSnackbar(true);
        //         setMessage("Form Deletion Successful");
        //         setLoading(false);
        //         setModal(false);
        //         refetch();
        //     })
        //     .catch((error) => {
        //         setSnackbar(true);
        //         setMessage(error.message);
        //     });
    };

    return (
        <div className="contact__table">
            <DeleteModal
                setModal={setModal}
                loading={loading}
                modal={modal}
                buttonLabel={"Delete"}
                text={"Are you sure you want to delete?"}
                onClickDelete={deleteContactUs}
            />
            <p className="contact__item">{element.name}</p>
            <p className="contact__item">{element.email}</p>
            <p className="contact__item">{element.phoneNumber}</p>
            <div className="promo__actions">
                <button className="btn-list" onClick={onClickEdit}>
                    View
                </button>

                {loading ? (
                    <div style={{ width: "4rem" }}>
                        <CircularProgress size={20} thickness={3} />
                    </div>
                ) : (
                    <button className="btn-list" onClick={() => setModal(true)}>
                        Delete
                    </button>
                )}
            </div>
        </div>
    );
};

export const Error: React.FC<{ error: any }> = ({ error }) => {
    const { setSnackbar, setMessage } = useContext(SnackbarContext);

    setSnackbar(true);
    setMessage(error.message ? error.message : "Some unknown error occurred");

    return (
        <div className="container-main">
            <div className="promo__box">
                <Empty />
            </div>
        </div>
    );
};
